import React, { Component, useReducer } from 'react';
import {Collapse,FooterToggler,FooterBrand,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import Instagram from '../images/instagram.png'
import Facebook from '../images/facebook.png'
import Twitter from '../images/twitter.png'
import Logo from '../images/logos/white_transparent.png'

  class Footer extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {

      };

    }

    componentDidMount() {
      
    }




    render() {
      if (window.location.href.indexOf("/live-session/") > -1) {
        return<>
        </>
      }
      return (
        <div  style={{minHeight: '250px', backgroundColor: '#32323D'}}>
          <Container>
            <Row style={{textAlign: 'left', color: '#FFFFFF'}}>
              <Col sm='3'>
                <br/><br/>
                <span style={{color: '#88C7E9', fontWeight: 'bold', fontFamily: 'Knewave', fontSize: '46px'}}>ONFIT</span>
                <h6 style={{marginTop: '50px', marginTop: '80px'}}>
                  Follow us on social media
                </h6>
                <Row style={{marginTop: '15px'}}>
                  <Col>
                    <a href='https://instagram.com/onfit.it?utm_medium=copy_link' target='_blank'><img src={Instagram} style={{width: '80%'}} /></a>
                  </Col>
                  <Col>
                    <a href='https://www.facebook.com/' target='_blank'><img src={Facebook} style={{width: '80%'}} /></a>
                  </Col>
                  <Col>
                    <a href='https://twitter.com/' target='_blank'><img src={Twitter} style={{width: '80%'}} /></a>
                  </Col>
                  <Col>

                  </Col>
                </Row>
              </Col>
              <Col sm='3'>
                <br/><br/>
                <h6 style={{color: '#88C7E9', fontWeight: 'bold'}}>
                  QUICK LINKS
                </h6>
                <br/>
                <a href='/home' style={{color: 'inherit'}}>
                  Home
                </a>
                <br/><br/>
                <a href='/trainers' style={{color: 'inherit'}}>
                  Trainers
                </a>
                <br/><br/>
                <a href='/explore' style={{color: 'inherit'}}>
                  Explore
                </a>
                <br/><br/>
                <a href='/pricing' style={{color: 'inherit'}}>
                  Pricing
                </a>
              </Col>
              <Col sm='3'>
                <br/><br/>
                <h6 style={{color: '#88C7E9', fontWeight: 'bold', opacity: 0}}>
                  QUICK LINKS
                </h6>
                <br/>
                <a href='/terms-and-conditions' style={{color: 'inherit'}}>
                  Terms and Conditions
                </a>
                <br/><br/>
                <a href='/privacy-policy' style={{color: 'inherit'}}>
                  Privacy Policy
                </a>
              </Col>
              <Col>
              
              </Col>
            </Row>
            <br/>
            <Row style={{color: '#FFFFFF', marginTop: '20px'}}>
                <Col>
                  &copy; ONFIT 2021. All rights reserved.
                </Col>
            </Row>
            <br/>
          </Container>
        </div>
      );
    }

  };
  
  export default withCookies(Footer);